<template>
  <v-card class="elevation-12" width="500">
    <v-toolbar flat>
      <v-col class="d-flex justify-space-around">
        <v-toolbar-title>
          <h3 style="font-size: 24px;">Resetear contraseña</h3>
        </v-toolbar-title>
      </v-col>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-text-field
            :disabled="loading"
            @keyup.enter="guardar"
            class="pa-0 ma-0"
            hide-details
            label="Ingrese nuevo password"
            type="password"
            v-model="password"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="guardar" :disabled="loading">Guardar</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Recupero",
  data() {
    return {
      username: "",
      password: "",
      loading: false
    };
  },
  methods: {
    ...mapActions(["showAlerta", "hideAlerta"]),
    async guardar() {
      const params = {
        username: this.username,
        password: this.password
      };

      let respuesta;
      try {
        this.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/usuario/Reset",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.loading = false;
      }

      this.showAlerta({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.$router.push({ name: "Login" });
      }
    },
    regreso() {
      this.hideAlerta();
      this.$router.push("Login");
    }
  },
  created() {
    this.username = this.$route.params.id;
  }
};
</script>

<style>
</style>